<template>
  <div class="ad-post-checkout">
    <div ref="topElement"></div>

    <div class="row">
      <div class="col-lg-8 col-sm-12">
        <div class="payment-form">
          <a-form :form="form">
            <a-collapse accordion :active-key="activeKey" expandIconPosition="right">
              <template #expandIcon="props">
                <a-icon type="caret-right" :rotate="props.isActive ? 90 : 0" />
              </template>
              <a-collapse-panel key="1" header="1. Contact Information">
                <div class="billing-form">
                  <a-row :gutter="16">
                    <a-col :span="12">
                      <a-form-item label="Name">
                        <a-input placeholder="Name" v-decorator="[
                          'name',
                          {
                            rules: [
                              {
                                required: true,
                                message: 'Please enter your name!',
                              },
                            ],
                          },
                        ]" />
                      </a-form-item>
                    </a-col>
                    <a-col :span="12">
                      <a-form-item label="Email">
                        <a-input placeholder="Email" v-decorator="[
                          'email',
                          {
                            rules: [
                              {
                                required: true,
                                type: 'email',
                                message: 'Please enter your email!',
                              },
                            ],
                          },
                        ]" />
                      </a-form-item>
                    </a-col>
                  </a-row>
                  <!-- <a-row>
                    <a-col :span="16">
                      <a-form-item label="Address">
                        <div id="autocomplete-container">
                          <a-input placeholder="Address" id="paymentLocation" ref="paymentLocationInput" />
                        </div>
                      </a-form-item>
                    </a-col>
                  </a-row> -->
                  <a-row :gutter="16">
                    <a-col :span="16">
                      <a-form-item label="Phone number">
                        <a-input placeholder="Phone number" v-decorator="[
                          'phoneNumber',
                          {
                            rules: [
                              {
                                required: !this.$route.query?.email,
                                message: 'Please enter your phone number!',
                              },
                            ],
                          },
                        ]" />
                      </a-form-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="16">
                      <a-form-item label="Coupon">
                        <a-input placeholder="Coupon code" v-decorator="['coupon']" />
                      </a-form-item>
                    </a-col>
                  </a-row>

                  <a-row>
                    <a-col :span="20">
                      <a-form-item>
                        <a-checkbox v-decorator="[
                          'agreement',
                          {
                            rules: [
                              {
                                required: true,
                                message: 'Please accept the agreement!',
                              },
                            ],
                          },
                        ]" />
                        I agree to the <NuxtLink to="/terms" target="_blank"> Terms and Conditions</NuxtLink>
                      </a-form-item>
                    </a-col>
                    <a-col :span="4">
                      <a-button type="primary" class="next-btn" icon="arrow-right" @click="handleSubmit">
                      </a-button>
                    </a-col>
                  </a-row>
                </div>
              </a-collapse-panel>
              <a-collapse-panel key="2" header="2. Payment" :disabled="disablePayment">
                <div class="billing-details">
                  <iframe :src="iframeUrl" class="payment-ifame" title="Iframe Example"></iframe>
                </div>
              </a-collapse-panel>
            </a-collapse>
          </a-form>
        </div>
      </div>
      <div class="col-lg-4 col-sm-12">
        <div class="payment-summary">
          <a-card title="Summary">
            <div class="price-summary">
              <div class="ad-price-details">
                <a-row>
                  <a-col :span="18" class="description">
                    {{ pricingDetails.itemDescription }} - ${{ pricingDetails.unitPrice }} X
                    {{ pricingDetails.selectedNumberOfAds }}
                  </a-col>
                  <a-col :span="6" class="value">${{ pricingDetails.totalPrice }}</a-col>
                </a-row>

                <a-row v-if="pricingDetails.percentageDiscount">
                  <a-col :span="18" class="description">
                    Discount ({{ pricingDetails.percentageDiscount }}%)
                  </a-col>
                  <a-col :span="6" class="value">
                    -${{ pricingDetails.totalDiscount }}
                  </a-col>
                  <a-col :span="24" class="expiring" v-if="pricingDetails.selectedNumberOfAds > 1">
                    (Ad credits are valid for 1 year from date of purchase.)
                  </a-col>
                </a-row>
              </div>
              <div class="ad-price-total">
                <!-- <a-row v-if="VAT>0">
                  <a-col :span="18" class="description">VAT ({{ VAT }}%)</a-col>
                  <a-col :span="6" class="value">${{ paymentValue.vat }}</a-col>
                </a-row> -->
                <a-row>
                  <a-col :span="18" class="description">Final Price</a-col>
                  <a-col :span="6" class="value">${{ pricingDetails.priceWithDiscount }}</a-col>
                </a-row>
              </div>
            </div>
          </a-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ArrowLeft from "vue-material-design-icons/ArrowLeft.vue";
import ArrowRight from "vue-material-design-icons/ArrowRight.vue";
import MapMarkerOutline from "vue-material-design-icons/MapMarkerOutline.vue";

import { getPaymentIframe } from "~/services/api/payment";

const FORMDATA = {
  operation: 1,
  TerminalNumber: process.env.cardcomTerminalNumber,
  UserName: process.env.cardcomeTerminalUserName,
  CoinID: 2,
  Language: "en",
  APILevel: 10,
  ErrorRedirectUrl: `${process.env.baseUrl}/payment-unsuccessfull`,
  IndicatorUrl: `https://admin.macherusa.com/api/payments/ads/activate`,
  ShowInvoiceHead: true,
  InvoiceHeadOperation: 1,
  codepage: 65001,
  "InvoiceHead.Language": "en"
};

export default {
  name: "CheckOut",
  scrollToTop: true,
  components: { ArrowRight, ArrowLeft, MapMarkerOutline },
  props: {
    pricingDetails: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      iframeUrl: "",
      disablePayment: true,
      activeKey: "1",
      VAT: 0,
      form: this.$form.createForm(this, { name: "payment_form" })
    };
  },
  // computed: {
  //   paymentValue() {
  //     const { VAT, pricingDetails: { priceWithDiscount = 0 } = {} } = this;
  //     const calculatedVat = (priceWithDiscount * VAT) / 100;
  //     return {
  //       totalPriceWithDiscount: priceWithDiscount,
  //       //   totalPriceWithDiscount: priceWithDiscount + calculatedVat,
  //       vat: calculatedVat,
  //     };
  //   },
  // },
  methods: {
    getPaymentForm() {
      const {
        pricingDetails,
        paymentValue,
        VAT,
      } = this;
      const params = new URLSearchParams();

      var mode = pricingDetails.mode;
      var SuccessRedirectUrl;
      // if (pricingDetails.itemDescription.toLowerCase().indexOf("resume") > -1)
      SuccessRedirectUrl = `${process.env.baseUrl}/PaymentSuccessRedirect`
      // else
      // SuccessRedirectUrl = `${process.env.baseUrl}/dashboard/job/PaymentSuccess`;

      //for jobs only move type of purchase
      if (pricingDetails.itemDescription.toLowerCase().indexOf("job") > -1) {
        var paymentStatus = "?paymentStatus=purchased";
        if (pricingDetails.selectedNumberOfAds > 1)
          paymentStatus = "?paymentStatus=purchasedCredits";
        else if (mode == "upgrade")
          paymentStatus = "?paymentStatus=purchasedUpgrade";

        SuccessRedirectUrl += paymentStatus;
      }
      if (pricingDetails.userCredit == 0)
        pricingDetails.userCredit = 1;

      var pricePerAd = parseInt(pricingDetails.totalPrice) / parseInt(pricingDetails.selectedNumberOfAds);
      var discount = -parseFloat(pricingDetails.totalDiscount);
      var discountDescription = "Discount (" + pricingDetails.percentageDiscount + "%)";
      const userId = this.$auth?.state?.user?.userId ?? null;
      // Assuming pricingDetails and other variables are already defined in your context

      const dealIdPart = pricingDetails.dealId ? `{}${pricingDetails.dealId}` : '';

      const formData = {
        ...FORMDATA,
        'InvoiceHead.Email': this.form.getFieldValue("email"),
        'InvoiceHead.SendByEmail': true,
        'InvoiceHead.CustName': this.form.getFieldValue("name"),
        'InvoiceHead.CoinID': 2,
        'InvoiceHead.ExtIsVatFree': this.VAT ? false : true,
        'InvoiceLines1.Description': pricingDetails.itemDescription,
        'InvoiceLines1.Quantity': pricingDetails.selectedNumberOfAds,
        'InvoiceLines1.Price': pricePerAd,
        "InvoiceLines1.IsVatFree": this.VAT ? false : true,
        // 'InvoiceLines2.Description': discountDescription,
        // 'InvoiceLines2.Quantity': 1,
        // 'InvoiceLines2.Price': discount,
        SuccessRedirectUrl: SuccessRedirectUrl,
        SumToBill: pricingDetails.priceWithDiscount,
        ProductName: pricingDetails.itemDescription,
        ReturnValue: `${pricingDetails.itemId}{}${pricingDetails.priceWithDiscount}{}${pricingDetails.type}{}${pricingDetails.selectedNumberOfAds}{}${mode}{}${pricingDetails.itemDescription}{}${this.form.getFieldValue("email")}{}${userId}{}${this.form.getFieldValue("coupon")}{}${this.form.getFieldValue("phoneNumber")}${dealIdPart}`,
      };
      // Add InvoiceLines2 only if discount is more than 0
      if (discount > 0 || discount < 0) {
        formData['InvoiceLines2.Description'] = discountDescription;
        formData['InvoiceLines2.Quantity'] = 1;
        formData['InvoiceLines2.Price'] = discount;
      }

      Object.keys(formData).forEach((key) => {
        params.append(`${key}`, `${formData[key]}`);
      });
      getPaymentIframe(params).then((res) => {
        const params = new URLSearchParams(res);
        this.iframeUrl = params.get("url");
      });
    },
    async handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err) => {
        if (!err) {
          this.disablePayment = false;
          this.activeKey = "2";
        }
      });

      //validtae coupon code
      const couponCode = this.form.getFieldValue("coupon");
      if (couponCode) {
        await this.validateCouponCode(couponCode); // Validate only if coupon code is provided
      }
      this.getPaymentForm();
    },
    validateCouponCode(coupon) {
      return new Promise((resolve, reject) => {
        var self = this;
        this.$store.dispatch("base/validateCoupon", { coupon }).then(function (couponData) {
          if (couponData.data.recordset && couponData.data.recordset.length > 0) {
            var discount = couponData.data.recordset[0].discount;
            self.pricingDetails.percentageDiscount = discount;
            self.pricingDetails.totalDiscount = parseFloat(
              (self.pricingDetails.totalPrice * (discount / 100)).toFixed(2)
            );

            self.pricingDetails.priceWithDiscount = parseFloat(self.pricingDetails.totalPrice - self.pricingDetails.totalDiscount.toFixed(2));
          }
          else {
            self.pricingDetails.percentageDiscount = 0;
            self.pricingDetails.totalDiscount = 0
            self.pricingDetails.priceWithDiscount = self.pricingDetails.totalPrice;
          }

          resolve(); // Resolve the promise when the coupon is valid

        });
      }).catch(err => {
        console.error("Error validating coupon:", err);
        reject(err); // Reject the promise if there's an error
      });

    },
    getLocation() {
      const form = this.form;

      if (navigator && navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          ({ coords: { latitude, longitude } = {} }) => {
            form.setFieldsValue({ lat: latitude });
            form.setFieldsValue({ lng: longitude });
            return Promise.resolve({ lat: latitude, lng: longitude });
          }
        );
      }
      return Promise.resolve({});
    },
    setupInputForLocation() {

      const self = this;
      //const locationInput = document.getElementById("paymentLocation");
      const form = self.form;


      this.$initAutocomplete("paymentLocation", {
        types: ["geocode"],
        language: "en",
        componentRestrictions: { country: ["us", "il"] }
      }).then(autocomplete => {
        if (autocomplete) {
          $(".pac-container").prependTo("#autocomplete-container").css("margin-top", "-3px");


          autocomplete.addListener("place_changed", () => {
            const {
              geometry: {
                location: { lat, lng },
              },
              formatted_address,
            } = autocomplete.getPlace();
            const isIsrael = formatted_address.match(/israel/gi) || [];
            self.VAT = isIsrael.length ? 17 : 0;
            this.$refs.paymentLocationInput.value = formatted_address;
            form.setFieldsValue({
              paymentLocation: formatted_address,
              lat: lat(),
              lng: lng(),
            });

          });
        }
      })

      // const options = {
      //   types: ["geocode"],
      //   language: "en",
      // };

      // const input = new google.maps.places.Autocomplete(locationInput, {
      //   ...options,
      //   lat,
      //   lng,
      // });


    },
  },
  mounted() {
    this.$refs.topElement.scrollIntoView({ behavior: 'smooth' });
    this.$nextTick(() => {

      const self = this;
      const {
        $auth = { state: { user: {} } },
        form,
      } = self;

      // this.getPaymentForm();
      // this.getLocation().then(
      //   (res) => this.setupInputForLocation(res));

      //this.setupInputForLocation();

      // Check if $auth and user are defined before setting form values
      //const user = $auth.state?.user || {};
      const user = {
        email: this.$route.query?.email || this.$auth?.state?.user?.email || '',
        name: this.$route.query?.name || this.$auth?.state?.user?.name || ''
      };

      form.setFieldsValue({ email: user.email });
      form.setFieldsValue({ name: user.name });

      // this.getPaymentForm();
      // this.getLocation().then(
      //   (res) => this.setupInputForLocation(res));

      // this.setupInputForLocation()
      // form.setFieldsValue({ email: user.email });
      // form.setFieldsValue({ name: user.name });
    });
    // localStorage.setItem("PaymentSuccess", "true");
  },
};
</script>
<style lang="scss">
.ad-post-checkout {
  width: 80%;
  margin: 2rem auto;
  font-family: 'Lexend', sans-serif;

  .payment-form {
    .ant-form {
      .ant-collapse {
        .ant-collapse-item {
          .ant-collapse-header {
            background: #2a41e8;
            color: #fff;
            line-height: 2.1rem;
            font-family: 'Lexend', sans-serif;
            font-size: 1.2rem;
          }

          &-disabled {
            .ant-collapse-header {
              background: #495be2be;
            }
          }
        }
      }
    }

    .billing-form {
      .ant-form-item {
        font-size: 1rem;
        font-family: 'Lexend', sans-serif;

        .ant-form-item-label {
          label {
            font: inherit;
            font-weight: 600;
          }
        }

        .ant-form-item-control-wrapper {
          .ant-form-item-control {
            a {
              color: #2a41e8;
            }

            .ant-form-explain {
              font-size: 1rem;
              font-family: 'Lexend', sans-serif;
            }
          }
        }
      }

      .next-btn {
        background: #f0f0f0;
        color: black;
        width: 74px;
        height: 40px;
        border: 1px solid #d8d0d0;
      }

      .ant-checkbox-wrapper {
        .ant-checkbox-checked .ant-checkbox-inner {
          background-color: #2a41e8
        }

        .ant-checkbox {
          .ant-checkbox-input {
            display: none;
          }

          .ant-checkbox-inner {
            height: 1.5rem;
            width: 1.5rem;
            border-radius: 5px;
            border: 2px solid #a59f9f96;
          }


        }
      }
    }

    .billing-details {
      .payment-ifame {
        width: 100%;
        height: 750px;
      }
    }
  }

  .payment-summary {
    .ant-card {
      margin-bottom: 1rem;

      .ant-card-head {
        background: #f0f0f0;
        color: #000;
      }

      .ant-card-body {
        background: #f9f9f9;

        .price-summary {
          font-size: 1rem;

          .ad-price-details {
            padding-bottom: 1rem;
            margin-bottom: 1rem;
            border-bottom: 2px solid #f0f0f0;
          }

          .value {
            font-weight: 700;
            text-align: right;
          }

          .expiring {
            font-size: 12px;
            font-style: italic;
          }
        }
      }
    }
  }
}

.hdpi.pac-logo {
  .pac-item {
    font-size: 1rem;
    font-family: 'Lexend', sans-serif;
  }

  &:after {
    display: none;
  }
}

.pac-logo {
  .pac-item {
    font-size: 1rem;
    font-family: 'Lexend', sans-serif;
  }

  &:after {
    display: none;
  }
}

@media (max-width: 768px) {
  .ad-post-checkout {
    width: 100%;
  }

  .ad-post-checkout {
    margin: 0;
  }

  .payment-summary {
    display: none;
  }

  .ad-post-checkout .payment-form .billing-form .next-btn {
    width: 40px;
  }
}
</style>